module.exports = __webpack_public_path__ + "img/ico_heart--orange.4ec2793a.svg";